// PLACEHOLDER: precios de ejemplo, edítalos aquí cuando quieras ajustarlos.
const servicePricing = {
  websites: {
    es: "Desde $4,000 MXN", // PLACEHOLDER
    en: "Starting at $4,000 MXN", // PLACEHOLDER
  },
  coordination: {
    es: "Cotización según el proyecto", // PLACEHOLDER
    en: "Quote based on project scope", // PLACEHOLDER
  },
};

export default servicePricing;
